module.exports = __webpack_public_path__ + "static/img/2560bgbanner@2x.0570d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/shop/2560bgbanner@2x.png
// module id = +Yik
// module chunks = 18